var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
              'btn-wrapper' ]},[(_vm.hasRecaptcha)?[_c('div',{staticClass:"btn-wrapper"},[_c('vue-recaptcha',{class:[
                  'captcha',
                  _vm.validCaptcha == true ? 'solved' : ''
                ],attrs:{"sitekey":"6LfHcdoUAAAAAB33moB0X3iT_g-I6ca_vEeQqSfT"},on:{"verify":_vm.onCaptchaVerified,"expired":_vm.onCaptchaExpired}}),_c('button',{class:[
                  'button',
                  _vm.validForm == true ? '' : 'disabled' ],attrs:{"type":"submit"},on:{"click":_vm.onSubmit}},[_c('p',{class:[
              'btn-label',
              _vm.isRunning == true ? 'hide' : '' ]},[_vm._v(_vm._s(_vm.label))]),_c('div',{class:[
              'loader',
              _vm.isRunning == true ? 'show' : '' ]})])],1),(_vm.validCaptcha === false)?_c('div',{staticClass:"captcha-error"}):_vm._e()]:[_c('button',{class:[
              'button',
              _vm.isValid == true ? '' : 'disabled' ],on:{"click":function (e) { return _vm.onSubmit(e); }}},[_c('p',{class:[
            'btn-label',
            _vm.isRunning == true ? 'hide' : '' ]},[_vm._v(" "+_vm._s(_vm.label))]),_c('div',{class:[
          'loader',
          _vm.isRunning == true ? 'show' : '' ]})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }